import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class DeadwoodRipGameMode extends GameMode {
    //Add your custom modes here!


    /*    public static readonly FREESPIN_EAST:string = "FREESPIN_EAST";
        public static readonly FREESPIN_WEST:string = "FREESPIN_WEST";
        public static readonly FREESPIN_COAST_TO_COAST:string = "FREESPIN_COAST_TO_COAST";
        public static readonly FREESPIN_PICK:string = "FREESPIN_PICK";


        //These are only used by the client, not the server. server only use RESPIN.
        public static readonly RESPIN_EAST:string = "RESPIN_EAST";
        public static readonly RESPIN_WEST:string = "RESPIN_WEST";*/

}